import { RefObject, useEffect, useState } from 'react';

const useIsInViewport = (
    ref: RefObject<HTMLElement | null>,
    options?: IntersectionObserverInit
) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => setIsIntersecting(entry.isIntersecting),
            options
        );

        observer.observe(element);

        return () => {
            observer.disconnect();
        };
    }, [ref, options]);

    return isIntersecting;
};

export default useIsInViewport;
